import React from "react";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";
import AdminOnly from "~/components/AdminOnly";

import "../officers-form.scss";
import OfficerAttachmentTable from "./OfficerAttachmentTable";
import useOfficerAttachment from "./useOfficerAttachment";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import Notification from "~/components/entities/notification/Notification";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

const OfficerAttacments = ({ type }) => {
  const { id } = useParams();

  const {
    filesData,
    loading,
    page,
    rows,
    first,
    totalRecords,
    onPageChange,
    isDataAvailable,
    setOpenDialog,
    fileSupported,
    openDialog,
    uploadFileHandler,
    entityData,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    getType,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,

    isAttachmentLoader,
    handleRestoreAttachment,
    temporaryMessage,
    restoreMessage,
    setRstoreMessage,
    setTemporaryMessage,
  } = useOfficerAttachment();

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "Address Updated",
      delete: "File(s) Deleted",
    };
  };

  return (
    <Card className="gen-card officer__attachments">
      <div className="flex justify-content-between mb-5">
        <div>
          <p className="officer__attachments--heading">Files & Attachments</p>
          <p className="officer__attachments--description">
            Files & Attachments for this{" "}
            {type === "officer" ? "officer" : "attorney"}.
          </p>
        </div>
        <AdminOnly>
          <div className="flex items-center space-x-2">
            <Button
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            >
              View History
              <span className="pi pi-history mb-1 ml-2" />
            </Button>

            <Button
              className="btn-primary font-semibold"
              onClick={() => setOpenDialog(true)}
            >
              Upload File
              <span className="pi pi-upload mb-1 ml-2" />
            </Button>
          </div>
        </AdminOnly>
      </div>
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <OfficerAttachmentTable
        files={filesData}
        loading={loading}
        page={page}
        rows={rows}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        isDataAvailable={isDataAvailable}
        setOpenDialog={setOpenDialog}
        type={type}
        first={first}
        handleAttachmentDelete={handleDeleteDocument}
      />
      <FileUploadModal
        entitydata={entityData?.entityData}
        showModal={openDialog}
        fileSupported={fileSupported}
        hideUploadModal={() => setOpenDialog(false)}
        setUploadedFile={uploadFileHandler}
        getService={getType}
        placeholder={"Choose a file to upload"}
        loading={!isFileUploaded}
        close={false}
        officerdata={entityData}
        relatedType={"OFFICER"}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="OFFICER"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default OfficerAttacments;
